import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.summary)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.summary.testAttempts) + " test attempts, " + _toDisplayString(_ctx.summary.completedAttempts) + " completed ", 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.summary.answerCount) + " questions, " + _toDisplayString(_ctx.correctPercent) + " correct", 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, "No attempts"))
}